import { Option } from '@sapphire/result';
import {
  SURVEY_CLASSIFICATION_KIND,
  SurveyClassification,
} from '@ps/survey-utils';

import {
  CHILD_SCOPE,
  ChildScopeRule,
} from '../../survey-creation-child-registry.helper';

export function hasSurveyTagsChanged(
  selectedTagIds: number[],
  linkedTagIds: number[],
): boolean {
  const linked = new Set(linkedTagIds);
  return (
    selectedTagIds.length !== linkedTagIds.length ||
    selectedTagIds.some((tagId) => !linked.has(tagId))
  );
}

const PROJECT_CLASSIFICATION_KINDS: readonly SurveyClassification['kind'][] = [
  SURVEY_CLASSIFICATION_KIND.GROUP_MC,
  SURVEY_CLASSIFICATION_KIND.TRACKER,
  SURVEY_CLASSIFICATION_KIND.GROUPED,
];

/** Project-backed families (group-mc/tracker/grouped) share one tag catalog across every locale, so a tag load fans out to `ALL`; everything else, including pre-draft where `kind` is still null, stays `ACTIVE`-only. */
export const surveyTagScope: ChildScopeRule = (kind) =>
  Option.from(kind).match({
    some: (classification) =>
      PROJECT_CLASSIFICATION_KINDS.includes(classification.kind)
        ? CHILD_SCOPE.ALL_PARTICIPANTS
        : CHILD_SCOPE.ACTIVE,
    none: () => CHILD_SCOPE.ACTIVE,
  });
